<template>
  <div class="transaction_list">
    <ModalDelete ref="ModalDelete" confirm-text="ya" @action="cancel">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold">Batalkan Transaksi</span>
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin untuk membatalkan transaksi "
          <span class="text-capitalize">{{ invoice_selected }}</span>"?
        </div>
      </template>
    </ModalDelete>
    <ModalDelete ref="ModalReceive" confirm-text="ya" confirm-color="primary" @action="receive">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold">konfirmasi penerimaan</span>
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin sudah menerima transaksi ini?
        </div>
      </template>
    </ModalDelete>
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>
          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <section-filter @cari="cari" @reset="resetFilter">
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-text-field v-model="invoiceFilter.value" outlined small dense hide-details class="searchInput"
                    placeholder="Cari Invoice">
                    <div slot="append">
                      <v-btn small elevation="2" color="success">
                        <v-icon center>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-select v-model="statusFilter.value" :items="statusList" item-text="label" item-value="value"
                    placeholder="Pilih Status" outlined dense></v-select>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <!-- <v-col cols="6" class="py-0">
                  <v-switch v-model="tempoFilter.value" class="mt-0" :true-value="'1'" :false-value="''" label="Tempo"
                    color="success" hide-details></v-switch>
                </v-col> -->
                <v-col v-if="tempoFilter.value" cols="6" class="py-0">
                  <v-select v-model="statusFilterTop.value" :items="statusListTop" item-text="label" item-value="value"
                    placeholder="Pilih Status Pembayaran" outlined dense></v-select>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-switch
                    v-model="negoFilter.value"
                    class="mt-0"
                    :true-value="'1'"
                    :false-value="''"
                    label="Transaksi Nego"
                    color="success"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" class="py-0">
                  <v-menu bottom offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateRangeText" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" hide-details="auto" outlined clearable densed class="datePickerSmall"
                        placeholder="Tanggal Transaksi" @click:clear="clearDate"></v-text-field>
                    </template>
                    <v-date-picker v-model="date" range no-title></v-date-picker>
                  </v-menu>

                </v-col>
                <v-col cols="12" sm="4" class="py-0">
                  <v-menu bottom offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="dateJatuhTempo" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on" hide-details="auto" outlined clearable densed class="datePickerSmall"
                        placeholder="Tanggal Jatuh Tempo" @click:clear="clearDateJatuhTempo"></v-text-field>
                    </template>
                    <v-date-picker v-model="dateJatuhTempoRange" range no-title></v-date-picker>
                  </v-menu>

                </v-col>
              </v-row>
            </section-filter>
            <div v-if="transactionData.length == 0 && !transactionPagination">
              <div class="pb-4">
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-col class="pb-0">
                    <vcl :width="300" :height="65">
                      <rect x="0" y="0" rx="2" ry="2" width="60" height="5" />
                      <rect x="260" y="0" rx="2" ry="2" width="40" height="5" />
                      <rect x="5" y="15" rx="2" ry="2" width="80" height="5" />
                      <rect x="5" y="25" rx="2" ry="2" width="95" height="5" />
                      <rect x="5" y="35" rx="2" ry="2" width="155" height="10" />
                      <rect x="5" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="5" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect x="240" y="18" rx="2" ry="2" width="35" height="12" />
                      <rect x="220" y="34" rx="2" ry="2" width="75" height="12" />
                      <rect x="220" y="50" rx="2" ry="2" width="75" height="12" />
                    </vcl>
                  </v-col>
                </v-card>
              </div>
            </div>
            <div v-else-if="transactionData.length == 0 && transactionPagination">
              <v-card outlined elevation="0" class="py-3 rounded-lg">
                <v-row class="justify-center">
                  <v-col cols="7" md="5">
                    <v-img width="100%" src="/assets/icons/belum-ada-pesanan.svg"></v-img>
                  </v-col>
                </v-row>
                <div class="text-center pb-3">
                  <div class="pt-1 text-body-1 font-weight-bold">
                    Belum ada pesanan
                  </div>
                  <div class="pt-1 text-body-2">Belanja kebutuhanmu segera</div>
                  <div class="pt-4">
                    <a :href="homepage" class="text-deco">
                      <v-btn depressed large color="black" text outlined
                        class="text-capitalize font-weight-bold rounded-lg">
                        <v-icon>mdi-cart</v-icon>Belanja Sekarang
                      </v-btn>
                    </a>
                  </div>
                </div>
              </v-card>
            </div>
            <div v-else>
              <div class="pb-4" v-for="data in transactionData" :key="data.trx_code">
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-row class="px-3">
                    <v-col class="py-1 text-body-2 my-auto">
                      <div class="d-block d-md-flex font-weight-bold">
                        <div>Transaksi</div>
                        <div class="pt-1 pt-md-0 pl-md-1">
                          {{ data.trx_code }}
                        </div>
                      </div>
                    </v-col>
                    <v-col class="py-0 text-right" v-if="data.trx_payment_method == 'midtrans'">
                      <v-btn @click="
                        showModalDelete(data.trx_midtrans_invoice, 'midtrans')
                        " text color="red" class="px-0" v-if="data.trx_status == 'created'">
                        <span class="text-capitalize text-body-2 font-weight-bold">Batalkan Transaksi</span>
                      </v-btn>
                    </v-col>
                    <v-col class="py-0 text-right" v-if="data.trx_payment_method == 'bank_transfer'">
                      <v-btn @click="
                        showModalDelete(
                          data.trx_midtrans_invoice,
                          'bank_transfer'
                        )
                        " text color="red" class="px-0" v-if="data.trx_status == 'created'">
                        <span class="text-capitalize text-body-2 font-weight-bold">Batalkan Transaksi</span>
                      </v-btn>
                    </v-col>
                    <v-col class="py-0 text-right" v-if="data.trx_payment_method == 'payment_store'">
                      <v-btn @click="
                        showModalDelete(
                          data.trx_midtrans_invoice,
                          'payment_store'
                        )
                        " text color="red" class="px-0" v-if="data.trx_status == 'created'">
                        <span class="text-capitalize text-body-2 font-weight-bold">Batalkan Transaksi</span>
                      </v-btn>
                    </v-col>
                    <v-col class="py-0 text-right" v-if="data.trx_payment_method == 'va'">
                      <v-btn @click="
                        showModalDelete(data.trx_midtrans_invoice, 'va')
                        " text color="red" class="px-0" v-if="data.trx_status == 'created'">
                        <span class="text-capitalize text-body-2 font-weight-bold">Batalkan Transaksi</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <div class="px-3 py-2">
                    <v-divider></v-divider>
                  </div>
                  <v-row class="pl-3 pl-md-5 pr-3">
                    <v-col cols="12" sm="7" md="8" class="pl-3 pl-md-5 py-0 text-body-2">
                      <div class="pt-3 d-flex">
                        <div class="text-body-2 font-weight-bold">
                          Pembelian
                        </div>
                        <div class="px-3">
                          <v-divider vertical></v-divider>
                        </div>
                        <div class="primary--text">
                          {{ data.trx_midtrans_invoice }}
                        </div>
                        <router-link to="/transaction" v-if="false">
                          <div>Invoice</div>
                        </router-link>
                      </div>
                      <div class="pt-3 d-md-flex">
                        <div class="d-flex">
                          <div class="font-size-13 grey--text text--darken-1">
                            Total :
                          </div>
                          <div class="pl-3 text-body-2 red--text font-weight-bold">
                            {{ data.trx_bill | toRupiah }}
                          </div>
                        </div>
                        <div class="pt-1 pt-md-0 d-flex">
                          <div class="pl-md-3 font-size-13 grey--text text--darken-1">
                            Waktu :
                          </div>
                          <div class="pl-3 text-body-2 font-weight-bold">
                            {{ data.trx_status_created_datetime | tanggal }}
                          </div>
                        </div>
                      </div>
                      <StatusTransaction :status="data.trx_status"></StatusTransaction>
                      <div class="pt-4"> 
                        <v-row>
                          <v-col cols="6" md="4" class="py-0">
                            <div class="font-size-13 grey--text text--darken-1">
                              Metode Pembayaran
                            </div>
                          </v-col>
                          <v-col cols="6" md="8" class="pl-0 pl-md-3 py-0">
                            <div class="font-size-13 font-weight-bold"
                              v-if="data.trx_payment_method == 'full_coin_gen'">
                              : Coin Gen
                            </div>
                            <div class="font-size-13 font-weight-bold" v-else>
                              : {{ data.trx_payment_text.payment_text }}
                            </div>
                          </v-col>
                          <v-col cols="6" md="4" class="pt-2 pb-0">
                            <div v-if="data.trx_payment_method == 'midtrans'"
                              class="font-size-13 grey--text text--darken-1">
                              Kode Pembayaran
                            </div>
                            <div v-else-if="
                              data.trx_payment_method == 'bank_transfer'
                            " class="font-size-13 grey--text text--darken-1">
                              Rekening Pembayaran
                            </div>
                            <div v-else-if="data.trx_payment_method == 'va'"
                              class="font-size-13 grey--text text--darken-1">
                              No. Virtual Account
                            </div>
                            <!-- <div
                              v-else-if="data.trx_payment_method == 'full_coin_gen'"
                              class="font-size-13 grey--text text--darken-1"
                            >Coin Gen</div>-->
                          </v-col> 
                          <v-col cols="6" md="8" class="pl-0 pl-md-3 pt-2 pb-0">
                            <div v-if="data.trx_payment_method != 'payment_store'"
                              class="font-size-13 font-weight-bold">
                              : {{ data.trx_midtrans_payment_code }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                      <div class="pt-3"> 
                        <v-row>
                          <v-col cols="6" md="4" class="py-0">
                            <div class="font-size-13 grey--text text--darken-1">
                              Tagihan Dibayarkan
                            </div>
                          </v-col>
                          <v-col cols="6" md="8" class="pl-0 pl-md-3 py-0">
                            <div class="font-size-13 font-weight-bold" >
                              : {{ data.payment_finance_amount |toRupiah }}
                            </div> 
                          </v-col>
                          <v-col cols="6" md="4" class="pt-2 pb-0"> 
                            <div  class="font-size-13 grey--text text--darken-1">
                             Sisa Tagihan
                            </div> 
                          </v-col> 
                          <v-col cols="6" md="8" class="pl-0 pl-md-3 pt-2 pb-0">
                            <div class="font-size-13 font-weight-bold red--text">
                              : {{ data.payment_finance_amount == 0 ? data.trx_bill : data.payment_remaining_debt |toRupiah }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="5" md="4" class="text-left text-md-right">
                      <div class="ml-0 ml-md-5">
                        <span class="text text-caption red--text"
                          v-if="data.trx_status == 'created' && data.is_top == '0'">Batas Pembayaran:
                          {{
                            data.trx_limit_confirmation_created | tanggaljam
                          }}</span>
                        <template v-if="data.is_top == '1'">
                          <span class="text text-caption red--text" v-if="data.payment_status !== 'paid'">
                            Pembayaran Termin <br>
                            Jatuh Tempo:
                            {{
                              data.termin_date | tanggal
                            }} <br>
                          </span>
                          <span v-if="data.is_top == '1'">
                            <span class="text-capitalize" :class="{
                              'green--text': data.payment_status == 'paid',
                              'red--text': data.payment_status !== 'paid',
                            }" v-if="data.payment_status">Status Tagihan: {{
                              data.payment_status }}</span>
                          </span> <br>
                        </template>
                        <template v-if="data.is_top !== '1'">
                          <span class="text text-caption red--text" v-if="data.trx_status == 'paid'">Batas Proses:
                            {{
                              data.trx_limit_confirmation_paid | tanggaljam
                            }}</span>
                        </template>
                        <span class="text text-caption red--text" v-if="data.trx_status == 'processed'">Batas Kirim:
                          {{
                            data.trx_limit_confirmation_processed | tanggaljam
                          }}</span>
                        <v-img v-if="data.trx_payment_text.payment_image" width="120" class="mx-auto"
                          :src="data.trx_payment_text.payment_image"></v-img>
                        <v-img v-if="data.trx_payment_method == 'payment_store'" width="40" class="mx-auto"
                          src="/assets/icons/market-icon.svg"></v-img>
                      </div>
                      <v-btn v-if="data.trx_status == 'created' && data.trx_pdf_url" height="45" width="260"
                        class="mt-1 rounded-lg btn-primary" @click="downloadPDF(data.trx_pdf_url)">
                        <div class="font-weight-bold text-body-2">
                          Cara Pembayaran
                        </div>
                      </v-btn>
                      <v-btn v-if="
                        data.trx_status == 'on_delivery' &&
                        loadTransaction == false
                      " height="45" width="260" class="mt-1 rounded-lg btn-primary"
                        @click="confirmReceived(data.trx_id)">
                        <div class="text-capitalize font-weight-bold rounded-lg">
                          Konfirmasi Penerimaan
                        </div>
                      </v-btn>
                      <v-btn outlined depressed height="45" width="260" class="mt-3 rounded-lg btn-primary-outline"
                        @click="gotoDetail(data.trx_midtrans_invoice)">
                        <div class="font-weight-bold text-body-2">
                          Detail Transaksi
                        </div>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
              <v-row class="pt-4 justify-center" v-if="transactionPagination.total_page > 1">
                <v-pagination v-model="page" @input="changePage" :length="transactionPagination.total_page"
                  class="elevation-0"></v-pagination>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfileMenu from "@/components/layout/store/ProfileMenu";
import StatusTransaction from "@/components/StatusTransaction";
import ModalDelete from "@/components/ModalDelete";
import moment from "moment";
import sectionFilter from "../../../components/sectionFilter.vue";
const filterStatusPayment = () => {
  return {
    value: "",
    comparison: "=",
    type: "string",
    field: "payment_status",
  }
}
export default {
  components: {
    ProfileMenu,
    sectionFilter,
    StatusTransaction,
    ModalDelete,
  },
  data() {
    return {
      statusListTop: [
        {
          label: "Semua Status Pembayaran Tagihan",
          value: "",
        },
        {
          label: "Pending",
          value: "pending",
        },
        {
          label: "Partial",
          value: "partial",
        },
        {
          label: "Paid",
          value: "paid",
        },
      ],
      statusList: [
        {
          label: "Semua Status Transaksi",
          value: "",
        },
        {
          value: "created",
          label: "Menunggu Pembayaran",
        },
        {
          value: "expired",
          label: "Transaksi Kedaluwarsa",
        },
        {
          value: "pending",
          label: "Menunggu Approval",
        },
        {
          value: "paid",
          label: "Menunggu Diproses Penjual",
        },
        {
          value: "processed",
          label: "Diproses Penjual",
        },
        {
          value: "on_delivery",
          label: "Proses Pengiriman",
        },
        {
          value: "completed",
          label: "Selesai",
        },
        {
          value: "rejected_admin",
          label: "Dibatalkan oleh Admin",
        },
        {
          value: "rejected_seller",
          label: "Dibatalkan oleh Penjual",
        },
        {
          value: "cancel",
          label: "Transaksi Dibatalkan",
        },
        {
          value: "pickup",
          label: "Pickup",
        },
        {
          value: "delivery",
          label: "Delivery",
        },
      ],
      negoFilter: {
        value: "",
        comparison: "=",
        type: "string",
        field: "trx_is_nego",
      },
      statusFilter: {
        value: "",
        comparison: "=",
        type: "string",
        field: "trx_status",
      },
      statusFilterTop: filterStatusPayment(),
      page: 1,
      filter: {
        type: {
          label: "No. Invoice",
          value: "invoice",
        },
        search: "",
        filterId: null,
        sortId: null,
        dateRange: null,
      },
      tempoFilter: {
        value: "",
        comparison: "=",
        type: "string",
        field: "is_top",
      },
      invoiceFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "trx_code",
      },
      date: [],
      periodTempoCreated: {
        value: '',
        comparison: 'bet',
        type: 'date',
        field: 'trx_status_created_datetime',
      },
      dateJatuhTempoRange: [],
      periodJatuhTempo: {
        value: '',
        comparison: 'bet',
        type: 'date',
        field: 'termin_date',
      },
      limit: 5,
      homepage: process.env.VUE_APP_HOMEPAGE,
      params: [],
      sortBy: "trx_id",
      sortDir: "DESC",
      invoice_selected: "",
    };
  },
  computed: {
    dateRangeText() {
      return this.date.join(' ~ ')
    },
   dateJatuhTempo() {
      return this.dateJatuhTempoRange.join(' ~ ')
    },
    ...mapState("transaction", [
      "loadTransaction",
      "transactionData",
      "transactionPagination",
    ]),
  },
  methods: {
    async clearDate() {
      this.date = await [];
      this.periodTempoCreated.value = '';
      this.cari();
    },
    resetFilter() {
      this.invoiceFilter.value = "";
      this.tempoFilter.value = "";
      this.statusFilter.value = "";
      this.periodJatuhTempo.value = ''
      this.dateJatuhTempoRange = []
      this.statusFilterTop = filterStatusPayment();
      this.cari();
    },
    cari() {
      this.params = [];
      if (this.$route.name == 'tempo-transaction') {
        this.tempoFilter.value = '1'
      }
      if (this.invoiceFilter.value) this.params.push(this.invoiceFilter);
      if (this.tempoFilter.value !== "") this.params.push(this.tempoFilter);
      if (this.statusFilter.value !== "") this.params.push(this.statusFilter);
      if (this.statusFilterTop.value !== "") this.params.push(this.statusFilterTop);
      if(this.date.length > 0){
      if (this.date.length == 1) {
        this.periodTempoCreated.value =this.createFilterDate(this.date[0],this.date[0]) 
      } else if (this.date.length == 2) {
        this.periodTempoCreated.value = this.createFilterDate(this.date[0],this.date[1]) 
      }
     }
     if(this.dateJatuhTempoRange.length > 0){
       if (this.dateJatuhTempoRange.length == 1) {
         this.periodJatuhTempo.value =this.createFilterDate(this.dateJatuhTempoRange[0],this.dateJatuhTempoRange[0]) 
        } else if (this.dateJatuhTempoRange.length == 2) {
          this.periodJatuhTempo.value =this.createFilterDate(this.dateJatuhTempoRange[0],this.dateJatuhTempoRange[1])  
        }
      }
      if (this.periodTempoCreated.value !== "") {
        this.params.push(this.periodTempoCreated);
      }
      if (this.periodJatuhTempo.value !== "") {
        this.params.push(this.periodJatuhTempo);
      }
      if (this.negoFilter.value !== "") this.params.push(this.negoFilter);
      this.sortBy = this.sortBy;
      this.sortDir = this.sortDir;
      this.page = 1;
      this.getTransaction(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      );
    },
    createFilterDate(date1,date2){
      return  moment(date1).format("YYYY-MM-DD") +"::" +moment(date2).format("YYYY-MM-DD");
    },
    
    async clearDateJatuhTempo() {
      this.dateJatuhTempoRange = await [];
      this.periodJatuhTempo.value = await '';
      // this.searchTrx();
    },
    ...mapActions("transaction", [
      "getTransaction",
      "cancelTransaction",
      "receiveTransaction",
      "cancelBank",
      "cancelStore",
      "cancelVA",
      "getStatisticTempoPayment"
    ]),

    showModalDelete(invoice, type) {
      this.invoice_selected = invoice;
      this.type_payment = type;
      this.$refs.ModalDelete.modalShow();
    },
    cancel() {
      if (this.type_payment == "midtrans") {
        this.cancelTransaction({ invoice: this.invoice_selected }).then(() => {
          this.getTransaction(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      } else if (this.type_payment == "bank_transfer") {
        this.cancelBank({ invoice: this.invoice_selected }).then(() => {
          this.getTransaction(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      } else if (this.type_payment == "payment_store") {
        this.cancelStore({ invoice: this.invoice_selected }).then(() => {
          this.getTransaction(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      } else if (this.type_payment == "va") {
        this.cancelVA({ invoice: this.invoice_selected }).then(() => {
          this.getTransaction(
            this.queryString({
              limit: this.limit,
              page: this.page,
              params: this.params,
              sort: this.sortBy,
              dir: this.sortDir,
            })
          );
        });
      }
    },
    downloadPDF(pdf) {
      window.open(pdf);
    },
    confirmReceived(id) {
      this.invoice_selected = id;
      this.$refs.ModalReceive.modalShow();
    },
    receive() {
      this.receiveTransaction({ trx_id: this.invoice_selected }).then(() => {
        this.getTransaction(
          this.queryString({
            limit: this.limit,
            page: this.page,
            params: this.params,
            sort: this.sortBy,
            dir: this.sortDir,
          })
        );
      });
    },
    gotoDetail(invoice) {
      this.$router.push({
        name: "transaction-detail",
        params: { id: invoice },
      });
    },
    changePage(page) {
      this.page = page;
      this.getTransaction({
        limit: this.limit,
        page: this.page,
        params: this.params,
        sort: this.sortBy,
        dir: this.sortDir,
      });
    },
  },
  created() {
    this.$store.dispatch("setPageTitle", "Transaksi");
    this.getStatisticTempoPayment()
    if (this.$route.query.status) {
      if (this.$route.query.status == 'unpaid') {
        let status = ''
        let allowedStatus = ['pending', 'partial']
        for (let i = 0; i < allowedStatus.length; i++) {
          status +=
            i < allowedStatus.length - 1
              ? allowedStatus[i] + "::"
              : allowedStatus[i];
        }
        this.statusFilterTop = {
          value: status,
          comparison: "=",
          type: "list",
          field: "payment_status",
        }
      } else {
        this.statusFilterTop.value = this.$route.query.status
      }
    }
    // this.getTransaction({
    //   limit: this.limit,
    //   page: this.page,
    //   params: this.params,
    //   sort: this.sortBy,
    //   dir: this.sortDir,
    // });
    this.cari()
  },
};
</script>
